export default {
    logout() {
        localStorage.clear();
        window.location.href = "/";
    },
    validateMobileNo(mobileNo) {
        let prefixEntered = mobileNo.substring(0, 3);
        const validPrefix = [
            "011",
            "012",
            "013",
            "014",
            "015",
            "016",
            "017",
            "018",
            "019"
        ];
        let status = validPrefix.includes(prefixEntered);
        if (!status || mobileNo.length !== 11) {
            return false;
        } else {
            return true;
        }
    },
    UrlGenerate(query, ids){
		var url = new URL(window.location.href);
		var search_params = url.searchParams;
		// new value of "id" is set to "101"
		search_params.set(query, ids);
		// change the search property of the main url
		url.search = search_params.toString();
		// the new url string
		var new_url = url.toString();
		// output : http://demourl.com/path?id=101&topic=main
		console.log(new_url);
        return new_url;
		//window.location.href = new_url;
	},    
    removeURLParameter(parameter){
        let url = window.location.href;
        //prefer to use l.search if you have a location/link object
        var urlparts= url.split('?');   
        if (urlparts.length>=2) {

            var prefix= encodeURIComponent(parameter)+'=';
            var pars= urlparts[1].split(/[&;]/g);

            //reverse iteration as may be destructive
            for (var i= pars.length; i-- > 0;) {    
                //idiom for string.startsWith
                if (pars[i].lastIndexOf(prefix, 0) !== -1) {  
                    pars.splice(i, 1);
                }
            }

            url= urlparts[0]+'?'+pars.join('&');
            return url;
        } else {
            return url;
        }
	},
    goTo(whereTo) {
        if(whereTo){
            window.location.href = '/'+whereTo;
        }
    },    
    cartCount() {
        if (localStorage.getItem("cart")) {
            var cart = JSON.parse(localStorage.getItem("cart"));
            return cart.length;
        } else {
            return 0;
        }

    },
    saveToCart(object) {
 
        if (localStorage.getItem("cart")) {
            var cart = JSON.parse(localStorage.getItem("cart"));

            const i = cart.findIndex(_item => _item.product_id === object.product_id);
            if (i > -1) cart[i] = object; // (2)
            else cart.push(object);

            //console.log(cart);
            // var status = find(cart, object);
            //  console.log(status);
            // cart.push(object);
        } else {
            var cart = [];
            cart.push(object);
        }
        localStorage.setItem("cart", JSON.stringify(cart));

        //cart = JSON.parse(localStorage.getItem("cart"));
        //console.log(cart);
    },
    removeFromCart(item) {
        var cart = JSON.parse(localStorage.getItem("cart"));
        if (cart) {
            cart.splice(cart.findIndex(function (i) {
                return i.product_id === item.product_id;
            }), 1);
            localStorage.setItem("cart", JSON.stringify(cart));
        }
    }, 
    cartAmount() {
        var total = 0
        if (localStorage.getItem("cart")) {
            var cart = JSON.parse(localStorage.getItem("cart"));
            for (var i = 0; i < cart.length; i++) {
                var price = cart[i].price;
                var qty = cart[i].quantity;
                total = parseFloat(total) + (qty * price);
            }
        }
        return total.toFixed(2);
    },
    updateCartQty(product_id, qty) {
        var cart = JSON.parse(localStorage.getItem("cart"));
        if (cart) {
            for (var i in cart) {
                if (cart[i].product_id == product_id) {
                    cart[i].quantity = qty;
                   break; //Stop this loop, we found it!
                }
            }
            localStorage.setItem("cart", JSON.stringify(cart));
        }
    },
    engNTbn(engNumber) {
        if(engNumber){
            var numbers = {
                '0': '০',
                '1': '১',
                '2': '২',
                '3': '৩',
                '4': '৪',
                '5': '৫',
                '6': '৬',
                '7': '৭',
                '8': '৮',
                '9': '৯'
            };
    
            var output = [];
            for (var i = 0; i < engNumber.length; ++i) {
                if (numbers.hasOwnProperty(engNumber[i])) {
                    output.push(numbers[engNumber[i]]);
                } else {
                    output.push(engNumber[i]);
                }
            }
            return output.join('');
        }
    },

    /**
     * Stores recently viewed urls to local storage along with their view times
     *
     * @param {String} key - the localStorage key where the list is stored
     * @param {String} url - the location of the page that was viewed
     * @param {Object} json - arbitrary json blob associated with a url
     * @param {Integer} limit - the max number of urls to save
     */
    
    addToRecentlyViewed (key, url, json, limit) {

    var viewedAt = Date.now(),
      recentlyViewed = localStorage[key],
      alreadyInRecents = false,
      limit = (limit) ? limit : 20;
  
    // initialize the local storage recent views if it hasn't been
  
    try {
      recentlyViewed = (recentlyViewed) ? JSON.parse(recentlyViewed) : [];
    } catch(e) {
      console.log('Error parsing json of recently viewed items');
      recentlyViewed = [];
    }
  
    // if the url is already in the set, update the view time and the data
  
    for (var i=0; i < recentlyViewed.length && !alreadyInRecents; i++) {
      if (recentlyViewed[i]["url"] && recentlyViewed[i]["url"] === url) {
        recentlyViewed[i]["viewedAt"] = viewedAt;
        recentlyViewed[i]["json"] = json;
        alreadyInRecents = true;
      }
    }
  
    // add the url to the recently viewed list if it wasn't updated in place
  
    if (!alreadyInRecents) {
      recentlyViewed.unshift({ url: url, viewedAt: viewedAt, json: json });
    }
  
    // sort urls by recently viewed times descending
  
    recentlyViewed.sort( function(a,b) {
      if ( a.viewedAt > b.viewedAt ) return -1;
      if ( a.viewedAt < b.viewedAt ) return 1;
      return 0;
    });
  
    // save a limited list of recently viewed items to local storage
  
    localStorage[key] = JSON.stringify( recentlyViewed.slice(0, limit) );
  }
};